import DeviceListPage from "./DeviceListPage";
import { firestore } from "firebase";
//import { DeviceList } from "../components/DeviceListTable";
import * as fs from "../firestore";

const DeviceMastersRef = firestore().collection(fs.Collection.DeviceMasters);
const WarrantiesRef = firestore().collection(fs.Collection.Warranties);

export default class AdminDeviceListPage extends DeviceListPage {
    getPageTitle(): string {
        return "機器一覧"
    }
    makeFetchDeviceMastersQuery( reverseOrder: boolean) {
        let query = DeviceMastersRef
            .orderBy("SerialNo", reverseOrder ? "desc" : "asc");
        return query;
    }

    makeFetchDeviceMastersQueryForwardMatch( reverseOrder: boolean, startcode: string, endcode: string) {
        let query = DeviceMastersRef
            .orderBy("SerialNo", reverseOrder ? "desc" : "asc")
            .where("SerialNo", ">=", startcode)
            .where("SerialNo", "<", endcode );
        return query;
    }

    makeFetchWarrantyQuery() {
        let query = WarrantiesRef
            .orderBy("SerialNo", "asc" )
        return query;
    }
}

